export default __webpack_public_path__ + "static/media/summary_planimages_108.e99f7ed7.png";